import {$http, Constants} from "@/store/actions/constants";

const url = `${Constants.BaseURL}/department`;

export const DepartmentActions = {
    find: ({commit, state}, search) => {
        return $http.get(url, {...state.authHeader, params: {search}}).then(r => {
            if (r.status === 200) {
                commit("SET_DEPARTMENTS", r.data);
            }
        });
    },

    delete: ({commit, state}, id) => {
        if (id) {
            return $http.delete(`${url}/${id}`, state.authHeader).then(r => {
                if (r.status === 200) {
                    commit("DELETE_DEPARTMENT", id);
                }
            });
        }
    },

    edit: ({commit, state}, data) => {
        return $http.put(`${url}/${data.id}`, data.data, state.authHeader).then(r => {
            if (r.status === 200) {
                commit("UPDATE_DEPARTMENT", data.data);
            }
        });
    },

    add: ({dispatch, commit, state}, data) => {
        return $http.post(url, data, state.authHeader).then(r => {
            if (r.status === 200) {
                dispatch("departmentFind", {limit: 20, offset: 0});
            }
        });
    },

    get: ({_, state}, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    }
};